import billing from "../api-provider";
import billingInstance from "../api-billing";
import billingMobile from "../api-provider-mobile";
import data_instance from "../api-ds";
import axios from "axios";

export const uploadDictation = async (payload, token) => {
  try {
    await billing({
      url: `/provider/uploadDictation`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return "Successfully added dictation!";
  } catch (error) {
    console.log("ERROR", error);
    return "ERROR";
  }
};

export const uploadDictatioProvider = async (payload, token) => {
  const host = window.location.host.split(":")[0];
  const clientDetails = {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`,
    clientId:
      host === "provider-web.services.orcicare.com"
        ? "11gq3cjmsgnmel096g5746re81"
        : "pj471754br2eo4kcruffaqt9m",
    clientSecret:
      host === "provider-web.services.orcicare.com"
        ? "ha15503nphj49sppm8et24kjg1ea658c1mc5kedifool639gfup"
        : "1539r70r9o2i1254e77kqciimd7oijh81tkm6e6tcio47kjla80g",
  };
  try {
    let response = await billingMobile({
      url: `/provider/uploadDictation`,
      method: "POST",
      headers: clientDetails,
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error.message);
    return error.message;
  }
};

export const getEncounterList = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getEncounterList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    return "ERROR";
  }
};

export const getProviderDetails = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getProviderDetails`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    return "ERROR";
  }
};

export const getDictationStatusCounts = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDictationStatusCounts`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    return "ERROR";
  }
};

export const getDictationNotes = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDictationNotes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
  }
};

export const getDictationMedCodesRecommendation = async (payload) => {
  try {
    let response = await data_instance({
      url: `/provider/getDictationMedCodesRecommendation`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    // return error.response.data;
  }
};

export const getDictationMedCodes = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDictationMedCodes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    // return error.response.data;
  }
};

export const getDSProcessedDictation = async (payload, token) => {
  try {
    let response = await data_instance({
      url: `/providerds/getDSProcessedDictation`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log(error.response);
    return error;
  }
};

export const getDictationList = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDictationList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const getEncounterPrechartingDetails = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getEncounterPrechartingDetails`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const getPatientCareGaps = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getPatientCareGaps`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const addPatientCareGap = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/addPatientCareGap`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const updatePatientCareGap = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/updatePatientCareGap`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const getPreChartDocuments = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDocuments`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const getPreChartDocument = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDocument`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const updateEncounterPrechartNote = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/updateEncounterPrechartNote`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR", error);
    throw new Error(error);
  }
};

export const getDictation = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDictation`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "arraybuffer",
      data: payload,
    });
    const mimeType = response.headers["content-type"];
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: mimeType }),
    );
    return url;
  } catch (error) {
    console.log("error: ", error);
    return "ERROR";
  }
};

export const getProviderListScribe = async (payload, id_token, token) => {
  try {
    const resp = await billing({
      url: `/scribe/getProviderList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${id_token}`,
      },
      data: payload,
      cancelToken: token || null,
    });
    return resp.data;
  } catch (error) {
    console.log("error: ", error);

    return [];
  }
};

export const getHCCDefinitions = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/getHCCDefinitions`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error: ", error);

    throw error;
  }
};

export const getCategoryDiagnosisCodes = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/getCategoryDiagnosisCodes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error: ", error);

    throw error;
  }
};

export const recommendCPTCodes = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/ai/agent/recommendCPTCodes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error recommendCPTCodes: ", error);

    throw error;
  }
};

export const getWebVersion = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getWebVersion",
      payload,
    });
    return data;
  } catch (error) {
    console.log("error getWebVersion: ", error);
  }
};

export const getRiskAdjustmentScore = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/getRiskAdjustmentScore`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error: ", error);

    throw error;
  }
};

export const getPracticeListScribe = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/scribe/getPracticeList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return [];
  }
};

export const getTotal = async (payload, id_token, token) => {
  try {
    const resp = await billing({
      url: `/scribe/getScribeMetrics`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${id_token}`,
      },
      data: payload,
      cancelToken: token || null,
    });
    const count = resp.data[0].COUNT;
    return count;
  } catch (error) {
    console.log("error getTotal: ", error);
    if (!axios.isCancel(error)) console.error("Unable to fetch Count:", error);
  }
};

export const getAverageTime = async (payload, id_token, token) => {
  try {
    const resp = await billing({
      url: `/scribe/getScribeMetrics`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${id_token}`,
      },
      data: payload,
      cancelToken: token || null,
    });
    const avg = resp.data.AVERAGE;
    return avg === "None" ? "" : parseFloat(avg / 1000).toFixed(2);
  } catch (error) {
    if (!axios.isCancel(error)) console.error("Unable to fetch Time:", error);
  }
};

export const getSLA = async (payload, id_token, token) => {
  try {
    const resp = await billing({
      url: `/scribe/getScribeMetrics`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${id_token}`,
      },
      data: payload,
      cancelToken: token || null,
    });
    const sla = resp.data.SLA;
    return sla === "None" ? "" : sla;
  } catch (error) {
    if (!axios.isCancel(error)) console.error("Unable to fetch SLA:", error);
  }
};

export const getScribeDictationList = async (payload, id_token, token) => {
  try {
    const response = await billing({
      url: `/scribe/getScribeDictationList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${id_token}`,
      },
      data: payload,
      cancelToken: token,
    });
    return response.data;
  } catch (error) {
    console.log("error getScribeDictationList: ", error);
    if (!axios.isCancel(error))
      console.error("Unable to fetch Dictation:", error);
    return [];
  }
};

export const updateDictationAssignment = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/scribe/updateDictationAssignment`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const getDiagnosisByDescription = async (payload) => {
  try {
    const resp = await data_instance({
      url: `/provider/getDiagnosisByDescription`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getDiagnosis = async (payload, token) => {
  try {
    const resp = await data_instance({
      url: `/provider/getDiagnosis`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getDiagnosisRisk = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/getDiagnosis`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getProcedure = async (payload, token) => {
  try {
    const resp = await data_instance({
      url: `/provider/getProcedure`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getModifier = async (payload, token) => {
  try {
    const resp = await billingInstance({
      url: `/getModifier`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get modifier");
    return [];
  }
};

export const addDictationMedCode = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/addDictationMedCode`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.error("Unable to get count");
    throw error;
  }
};

export const generateDictationPDF = async (payload, token) => {
  try {
    let { data } = await billing({
      url: "/provider/generateDictationPDF",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });
    return data;
  } catch (error) {
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const updateDictationMedCode = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/updateDictationMedCode`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const updateDictationNotes = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/scribe/updateDictationNotes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const updateDictationStatus = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/scribe/updateDictationStatus`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const getDictationAudit = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getDictationAudit`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    const list = resp.data;
    return list;
  } catch {
    console.error("Unable to get count");
  }
};

export const addDictationAudit = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/addDictationAudit`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getUnassignedDictations = async (payload, id_token, token) => {
  try {
    const resp = await billing({
      url: `/scribe/getUnassignedDictations`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${id_token}`,
      },
      data: payload,
      cancelToken: token,
    });
    return resp.data;
  } catch (error) {
    console.log("error getUnassignedDictations: ", error);
    return [];
  }
};

export const updateEncounterDetails = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/updateEncounterDetails`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const updateDictationDetails = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/updateDictationDetails`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const getPracticeScribingStatusSummary = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getPracticeScribingStatusSummary`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getPracticeScribingStatusDetails = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getPracticeScribingStatusDetails`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getAnsServNotificationPreferences = async (payload, token) => {
  console.log("token>>>: ", token);
  try {
    const resp = await billing({
      url: `/provider/getAnsServNotificationPreferences`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const updateAnsServNotificationPreferences = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/updateAnsServNotificationPreferences`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const getPracticeDocuments = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/scribe/getPracticeDocuments`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return [];
  }
};

export const saveDictationMedCodes = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/saveDictationMedCodes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return [];
  }
};

export const getPracticeProviderLicenses = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getPracticeProviderLicenses`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error getPracticeProviderLicenses: ", error);
    throw error;
  }
};

export const generateAIChatResponse = async (payload, token, onChunk) => {
  try {
    const resp = await billing({
      url: `/ai/generateAIChatResponse`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
      responseType: "text",
      transformResponse: [(data) => data],
    });

    const decoder = new TextDecoder("utf-8");

    // Split into lines from streaming events
    const lines = resp.data
      .split("\n")
      .filter((line) => line.startsWith("data:"))
      .map((line) => line.replace(/^data:\s*/, "")); // remove 'data:'
    let accumulatedText = "";

    for (const l of lines) {
      let text = decoder.decode(new TextEncoder().encode(l));
      accumulatedText += text;
      if (onChunk) onChunk({ response: accumulatedText });
      await new Promise((resolve) => setTimeout(resolve, 20));
    }
  } catch (error) {
    console.log("error generateAIChatResponse: ", error);
    throw error;
  }
};

export const updateMedCodingRecommendation = async (payload) => {
  try {
    const resp = await data_instance({
      url: `/provider/updateMedCodingRecommendation`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const getEncounterServiceTrackerList = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getEncounterServiceTrackerList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const uploadDictationAddonNote = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/uploadDictationAddonNote`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (e) {
    throw Error(e);
  }
};

export const getDictationAddonNotes = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getDictationAddonNotes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return "ERROR";
  }
};

export const updateEncounterServiceTracker = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/updateEncounterServiceTracker`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getScribeUserList = async (token, id_token) => {
  try {
    const resp = await billing({
      url: `/scribe/getScribeUserList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${id_token}`,
      },
      data: { type: "Scribe" },
      cancelToken: token,
    });
    return resp.data;
  } catch {
    return [];
  }
};

export const getProceduresByDescription = async (payload) => {
  try {
    const resp = await data_instance({
      url: `/provider/getProceduresByDescription`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    return resp.data;
  } catch {
    return [];
  }
};

export const searchDictations = async (payload, token) => {
  try {
    const response = await billing({
      url: "/scribe/searchDictations",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    return "ERROR";
  }
};

export const getDictationMessages = async (payload, token) => {
  try {
    const response = await billing({
      url: "/scribe/getDictationMessages",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const updateDictationHoldMessage = async (payload, token) => {
  try {
    const response = await billing({
      url: "/scribe/updateDictationHoldMessage",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    return "ERROR";
  }
};

export const getNoteTemplatesByPractice = async (payload, token) => {
  try {
    const response = await billing({
      url: "/provider/getNoteTemplatesByPractice",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    return ["SOAP"];
  }
};

export const getNoteCategoryByPractice = async (payload, token) => {
  try {
    const response = await billing({
      url: "/provider/getNoteCategoryByPractice",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    return undefined;
  }
};

export const uploadDocument = async (payload, file, token) => {
  try {
    const data = new FormData();
    data.append("file", file);
    data.append("request_json", JSON.stringify(payload));
    let response = await billingInstance({
      url: "/uploadDocument",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    if (response.data.status === "Success") {
      return response.data.status;
    }
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getDictationDetails = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getDictationDetails`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getEncounterText = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/enhanceNotesText`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getRecentDictationSummary = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getRecentDictationSummary`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getRecentEMRAppointmentLoadDetails = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getRecentEMRAppointmentLoadDetails`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getActivityLog = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getActivityLog`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getPracticeProviderMobileUsers = async (payload, token) => {
  try {
    let response = await billing({
      url: `/provider/getPracticeProviderMobileUsers`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const uploadEMRAppointmentLoadFile = async (payload, token) => {
  try {
    const response = await billing({
      url: `/provider/uploadEMRAppointmentLoadFile`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });

    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getUserMessages = async (payload, token) => {
  try {
    let response = await billing({
      url: `/usermessaging/getUserMessages`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const sendUserMessage = async (payload, token) => {
  try {
    let response = await billing({
      url: `/usermessaging/sendUserMessage`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const getNewMessageCount = async (payload, token) => {
  try {
    let response = await billing({
      url: `/usermessaging/getNewMessageCount`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const markMessagesAsRead = async (payload, token) => {
  try {
    let response = await billing({
      url: `/usermessaging/markMessagesAsRead`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};
